import { render, staticRenderFns } from "./TransferChildOrders.vue?vue&type=template&id=74081c7f"
import script from "./TransferChildOrders.vue?vue&type=script&lang=js"
export * from "./TransferChildOrders.vue?vue&type=script&lang=js"
import style0 from "./TransferChildOrders.vue?vue&type=style&index=0&id=74081c7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports